var map = {
	"./decidim/avatar-multiuser.png": 83929,
	"./decidim/brands/google.svg": 49172,
	"./decidim/cc-badge.png": 85647,
	"./decidim/decidim-logo.svg": 93771,
	"./decidim/default-avatar.svg": 91183,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 30965,
	"./decidim/icons.svg": 17838,
	"./decidim/pattern.png": 19037,
	"./decidim/placeholder-card-g.svg": 15026,
	"./decidim/placeholder-card-l.svg": 19481,
	"./decidim/placeholder.jpg": 51400,
	"./decidim/remixicon.symbol.svg": 95850,
	"./decidim/vendor/leaflet/layers-2x.png": 81511,
	"./decidim/vendor/leaflet/layers.png": 78926,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 41123,
	"./decidim/vendor/leaflet/marker-icon.png": 40986,
	"./decidim/vendor/leaflet/marker-shadow.png": 88553,
	"./decidim/vendor/social-share-button/douban.svg": 58925,
	"./decidim/vendor/social-share-button/email.svg": 19342,
	"./decidim/vendor/social-share-button/facebook.svg": 44230,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 79946,
	"./decidim/vendor/social-share-button/hacker_news.svg": 92030,
	"./decidim/vendor/social-share-button/linkedin.svg": 71076,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 36381,
	"./decidim/vendor/social-share-button/pinterest.svg": 86584,
	"./decidim/vendor/social-share-button/reddit.svg": 39890,
	"./decidim/vendor/social-share-button/telegram.svg": 16691,
	"./decidim/vendor/social-share-button/tumblr.svg": 91376,
	"./decidim/vendor/social-share-button/twitter.svg": 67475,
	"./decidim/vendor/social-share-button/vkontakte.svg": 84217,
	"./decidim/vendor/social-share-button/wechat.svg": 48588,
	"./decidim/vendor/social-share-button/whatsapp.svg": 60516,
	"./decidim/vendor/social-share-button/x.svg": 97622,
	"./decidim/vendor/social-share-button/xing.svg": 75522
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56114;